import categoryMap from "resources/json/category-map.json";
import { encode } from "../../util/helper/encode";
import { ICategoryMap } from "../interfaces/category-api.type";

const CATEGORY_MAP: ICategoryMap[] = categoryMap;

export function getCategory(tier0: string): ICategoryMap {
  // eslint-disable-next-line no-param-reassign
  tier0 = encode(tier0, "(_|-)", " ");
  return CATEGORY_MAP.filter((cat) => cat.t0.toLowerCase() === tier0.toLowerCase())[0];
}

export function getTier1s(tier0: string): string[] {
  const matchedCategory = CATEGORY_MAP.find((category) => {
    const { t0 } = category;
    return t0.toLowerCase() === tier0.toLowerCase();
  });

  if (!matchedCategory) {
    return [];
  }
  const { sub } = matchedCategory;
  return sub.map((el: any) => {
    const { t1 } = el;
    return t1;
  });
}
